// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModeratorBlog_blogPostContainer__CjQ\\+D {
  margin: 10px 20px;
  border-radius: 15px;
  background-color: #fff;
  padding: 15px;
}

.ModeratorBlog_textAreaContainer__d4Lsk {
  width: 100%;
}

.ModeratorBlog_blogPostTextArea__uiq90 {
  border: 1px solid #d9d9d9;
  border-radius: 15px;
  background-color: transparent;
  padding: 15px 50px 15px 15px;
  width: 100%;
  
  resize: none;
  overflow-y: auto !important; /* Enables scroll view for long blogs */   
  box-sizing: border-box;
  font-family: inherit;
  outline: none;

  font-size: 14px;
  line-height: 1.3;          
  white-space: pre-line;     
}

.ModeratorBlog_blogPostTextArea__uiq90:disabled {
  color: #333;
  opacity: 1;
  -webkit-text-fill-color: #333;
  cursor: default;
  background-color: #fafafa;
}

.ModeratorBlog_impactfulMemberModalTextArea__MpYjt {
  width: 100%;
  min-height: 220px;
  padding: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  resize: none;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.6;
  font-family: inherit;
  outline: none;
  background-color: #fff;
}

.ModeratorBlog_impactfulMemberModalTextArea__MpYjt:focus {
  border-color: #1976d2;
}

.ModeratorBlog_charCountContainer__tQVHp {
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
  font-size: 13px;
  color: #666;
}

.ModeratorBlog_buttonContainer__7P7vs {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 10px;
}

.ModeratorBlog_postButton__VdTUF {
  background-color: #2168b2;
  color: #fff;
  border: none;
  border-radius: 15px;
  padding: 3px 25px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s ease;
  outline: none !important;
}

.ModeratorBlog_postButton__VdTUF:hover:not(:disabled) {
  opacity: 0.9;
}

.ModeratorBlog_postButton__VdTUF:disabled {
  background-color: #a2c3e4;
  cursor: not-allowed;
}
.ModeratorBlog_cancelButton__S6Qxm {
  background: none;
  border: none;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  outline: none !important;
}

.ModeratorBlog_cancelButton__S6Qxm:disabled {
  color: #bdbdbd;
  cursor: not-allowed;
}

.ModeratorBlog_newBlogContainer__5c\\+xY {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.ModeratorBlog_newBlogButton__Q1F6A {
  background: none;
  border: none;
  color: #4795de;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  outline: none !important;
}
.ModeratorBlog_newBlogButton__Q1F6A:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ModeratorBlog_newBlogAddBtnText__HZDml {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ModeratorBlog_textAreaContainer__d4Lsk {
  position: relative;
}

.ModeratorBlog_inlineActionContainer__9mCvz {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}

.ModeratorBlog_blogActionDropdown__5ZBrz {
  min-width: 110px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  background: #fff;
  font-size: 13px;
}
.ModeratorBlog_archivedBlogWrapper__-Zb86 {
  margin: 10px 20px 24px 20px;
}

.ModeratorBlog_archivedContainer__Glm1e {
  position: relative;
  margin: 0;
  padding: 16px;
  border-radius: 15px;
  background-color: #fff;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Dropdown positioned at top-right of card */
.ModeratorBlog_archivedActionDropDown__4Z6-C {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
}

/* Header row */
.ModeratorBlog_archivedBlogHeader__AlLtD {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-right: 40px; /* Prevent overlap with dropdown */
}

/* Archived date */
.ModeratorBlog_archivedDate__I0cag {
  margin-top: 4px;
  margin-left: 4px;
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

/* Blog content */
.ModeratorBlog_archivedBlogContent__APrCr {
  padding-top: 8px;
  padding-right: 40px; /* Space for dropdown */

  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/Moderator/ModeratorBlog.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,WAAW;;EAEX,YAAY;EACZ,2BAA2B,EAAE,uCAAuC;EACpE,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;;EAEb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB,EAAE,uBAAuB;;EAE5C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[".blogPostContainer {\r\n  margin: 10px 20px;\r\n  border-radius: 15px;\r\n  background-color: #fff;\r\n  padding: 15px;\r\n}\r\n\r\n.textAreaContainer {\r\n  width: 100%;\r\n}\r\n\r\n.blogPostTextArea {\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 15px;\r\n  background-color: transparent;\r\n  padding: 15px 50px 15px 15px;\r\n  width: 100%;\r\n  \r\n  resize: none;\r\n  overflow-y: auto !important; /* Enables scroll view for long blogs */   \r\n  box-sizing: border-box;\r\n  font-family: inherit;\r\n  outline: none;\r\n\r\n  font-size: 14px;\r\n  line-height: 1.3;          \r\n  white-space: pre-line;     \r\n}\r\n\r\n.blogPostTextArea:disabled {\r\n  color: #333;\r\n  opacity: 1;\r\n  -webkit-text-fill-color: #333;\r\n  cursor: default;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.impactfulMemberModalTextArea {\r\n  width: 100%;\r\n  min-height: 220px;\r\n  padding: 16px;\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 12px;\r\n  resize: none;\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n  font-family: inherit;\r\n  outline: none;\r\n  background-color: #fff;\r\n}\r\n\r\n.impactfulMemberModalTextArea:focus {\r\n  border-color: #1976d2;\r\n}\r\n\r\n.charCountContainer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 6px;\r\n  font-size: 13px;\r\n  color: #666;\r\n}\r\n\r\n.buttonContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 16px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.postButton {\r\n  background-color: #2168b2;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 15px;\r\n  padding: 3px 25px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: opacity 0.2s ease;\r\n  outline: none !important;\r\n}\r\n\r\n.postButton:hover:not(:disabled) {\r\n  opacity: 0.9;\r\n}\r\n\r\n.postButton:disabled {\r\n  background-color: #a2c3e4;\r\n  cursor: not-allowed;\r\n}\r\n.cancelButton {\r\n  background: none;\r\n  border: none;\r\n  color: #666;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  outline: none !important;\r\n}\r\n\r\n.cancelButton:disabled {\r\n  color: #bdbdbd;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.newBlogContainer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.newBlogButton {\r\n  background: none;\r\n  border: none;\r\n  color: #4795de;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  outline: none !important;\r\n}\r\n.newBlogButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n.newBlogAddBtnText {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.textAreaContainer {\r\n  position: relative;\r\n}\r\n\r\n.inlineActionContainer {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  z-index: 1;\r\n}\r\n\r\n.blogActionDropdown {\r\n  min-width: 110px;\r\n  padding: 6px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid #d9d9d9;\r\n  background: #fff;\r\n  font-size: 13px;\r\n}\r\n.archivedBlogWrapper {\r\n  margin: 10px 20px 24px 20px;\r\n}\r\n\r\n.archivedContainer {\r\n  position: relative;\r\n  margin: 0;\r\n  padding: 16px;\r\n  border-radius: 15px;\r\n  background-color: #fff;\r\n  border: 1px solid #e8e8e8;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* Dropdown positioned at top-right of card */\r\n.archivedActionDropDown {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  z-index: 2;\r\n}\r\n\r\n/* Header row */\r\n.archivedBlogHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n  padding-right: 40px; /* Prevent overlap with dropdown */\r\n}\r\n\r\n/* Archived date */\r\n.archivedDate {\r\n  margin-top: 4px;\r\n  margin-left: 4px;\r\n  font-size: 12px;\r\n  color: #666;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Blog content */\r\n.archivedBlogContent {\r\n  padding-top: 8px;\r\n  padding-right: 40px; /* Space for dropdown */\r\n\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n  color: #333;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blogPostContainer": `ModeratorBlog_blogPostContainer__CjQ+D`,
	"textAreaContainer": `ModeratorBlog_textAreaContainer__d4Lsk`,
	"blogPostTextArea": `ModeratorBlog_blogPostTextArea__uiq90`,
	"impactfulMemberModalTextArea": `ModeratorBlog_impactfulMemberModalTextArea__MpYjt`,
	"charCountContainer": `ModeratorBlog_charCountContainer__tQVHp`,
	"buttonContainer": `ModeratorBlog_buttonContainer__7P7vs`,
	"postButton": `ModeratorBlog_postButton__VdTUF`,
	"cancelButton": `ModeratorBlog_cancelButton__S6Qxm`,
	"newBlogContainer": `ModeratorBlog_newBlogContainer__5c+xY`,
	"newBlogButton": `ModeratorBlog_newBlogButton__Q1F6A`,
	"newBlogAddBtnText": `ModeratorBlog_newBlogAddBtnText__HZDml`,
	"inlineActionContainer": `ModeratorBlog_inlineActionContainer__9mCvz`,
	"blogActionDropdown": `ModeratorBlog_blogActionDropdown__5ZBrz`,
	"archivedBlogWrapper": `ModeratorBlog_archivedBlogWrapper__-Zb86`,
	"archivedContainer": `ModeratorBlog_archivedContainer__Glm1e`,
	"archivedActionDropDown": `ModeratorBlog_archivedActionDropDown__4Z6-C`,
	"archivedBlogHeader": `ModeratorBlog_archivedBlogHeader__AlLtD`,
	"archivedDate": `ModeratorBlog_archivedDate__I0cag`,
	"archivedBlogContent": `ModeratorBlog_archivedBlogContent__APrCr`
};
export default ___CSS_LOADER_EXPORT___;
